export const TEXTS = {
  REQUEST_REPORT_MODAL_TITLE: 'Отчет по рекламным кампаниям',
  REQUEST_REPORT_MODAL_CONTENT: 'Доступен запрос отчёта по всем рекламным кампаниям за последние 90 дней.',
  REQUEST_AUDIO_REPORT_MODAL_CONTENT:
    'Доступен запрос отчёта по всем рекламным кампаниям за последние 90 дней. Отчёт будет сформирован и отправлен на электронную почту, также будет доступен в разделе «Отчеты».',
  LABEL: 'Выберите даты',
  PERIOD_LABEL: 'Период',
  AUDIO_REPORT_SCOPE_LABEL: 'Тип отчета',
  AUDIO_REPORT_SCOPE_COMMON: 'Общий',
  AUDIO_REPORT_SCOPE_ADDRESSES: 'По адресам',
  AUDIO_REPORT_SCOPE_PROMOS: 'По промороликам',
  AUDIO_REPORT_PROMOS_LABEL: 'Проморолики',
  AUDIO_REPORT_PROMOS_PLACEHOLDER: 'Выберите проморолики',
  AUDIO_REPORT_PROMOS_SELECTED_TITLE: 'Выбранные проморолики',
  AUDIO_REPORT_PROMOS_SELECTED_COUNT: (selectedCount: number) => `Выбрано: ${selectedCount}`,
  AUDIO_REPORT_PROMOS_RESET: 'Сбросить',
  AUDIO_REPORT_PROMOS_SEARCH_PLACEHOLDER: 'Поиск...',
  AUDIO_REPORT_PROMOS_SORT_LABEL: 'Сначала новые',
  AUDIO_REPORT_PROMOS_FILTER_LABEL: 'Фильтрация по статусу кампании',
  AUDIO_REPORT_PROMOS_STATUS_ACTIVE: 'Активна',
  AUDIO_REPORT_PROMOS_STATUS_STOPPED: 'Остановлена',
  AUDIO_REPORT_PROMOS_PLAY: (title: string) => `Воспроизвести «${title}»`,
  AUDIO_REPORT_PROMOS_PAUSE: (title: string) => `Приостановить «${title}»`,
  AUDIO_REPORT_PROMOS_LOADING: 'Загружаем проморолики',
  AUDIO_REPORT_ADDRESSES_LABEL: 'Адреса',
  AUDIO_REPORT_ADDRESSES_SELECTED_TITLE: 'Выбранные адреса',
  AUDIO_REPORT_ADDRESSES_SELECTED_COUNT_SHORT: (selectedCount: number, totalCount: number) =>
    `(${selectedCount}/${totalCount})`,
  AUDIO_REPORT_ADDRESSES_SEARCH_PLACEHOLDER: 'Поиск...',
  AUDIO_REPORT_ADDRESSES_TAG_SEARCH_PLACEHOLDER: 'Поиск тегов',
  AUDIO_REPORT_ADDRESSES_SELECTED_COUNT: (selectedCount: number) => `Выбрано: ${selectedCount}`,
  AUDIO_REPORT_ADDRESSES_SELECT_ALL: 'Выбрать все',
  AUDIO_REPORT_ADDRESSES_RESET: 'Сбросить',
  AUDIO_REPORT_ADDRESSES_EMPTY: 'Адреса не найдены',
  AUDIO_REPORT_ADDRESSES_LOADING: 'Загружаем адреса',
  AUDIO_REPORT_ADDRESSES_CLEAR_TAGS: 'Очистить',
  AUDIO_REPORT_ADDRESSES_MORE_TAGS: (hiddenCount: number) => `Еще ${hiddenCount}`,
  AUDIO_REPORT_ADDRESSES_HIDE_TAGS: 'Свернуть',
  AUDIO_REPORT_ADDRESSES_REMOVE_TAG: 'Удалить тег',
  AUDIO_REPORT_ADDRESSES_SHOW_ALL_TAGS: 'Показать все выбранные теги адресов',
  AUDIO_REPORT_ADDRESSES_EXACT_SEARCH: 'Точный поиск',
  AUDIO_REPORT_ADDRESSES_EXACT_SEARCH_TOOLTIP:
    'Если точный поиск включен — показываются результаты со всеми выбранными тегами.\nЕсли выключен — показываются результаты, содержащие любой из выбранных тегов.',
  HINT: 'Отчёт будет сформирован и отправлен на электронную почту. Также отчет будет доступен в разделе «Отчеты»',
  REQUEST: 'Запросить',
  REQUEST_AUDIO_REPORT: 'Запросить отчет',
  CLOSE: 'Закрыть',
  CANCEL: 'Отменить',
  ADD_EXTERNAL_RECIPIENTS: 'Добавить внешних получателей',
  REPORT_RECIPIENTS_LABEL: 'Получатели отчета',
  REPORT_RECIPIENTS_SELECTED_TITLE: 'Выбранные участники',
  REPORT_RECIPIENTS_SELECTED_COUNT_SHORT: (selectedCount: number, totalCount: number) =>
    `(${selectedCount}/${totalCount})`,
  REPORT_RECIPIENTS_PLACEHOLDER: (selectedCount: number, totalCount: number) =>
    `Выбранные участники (${selectedCount}/${totalCount})`,
  REPORT_RECIPIENTS_SEARCH_PLACEHOLDER: 'Поиск...',
  REPORT_RECIPIENTS_SELECTED_COUNT: (selectedCount: number) => `Выбрано: ${selectedCount}`,
  REPORT_RECIPIENTS_SELECT_ALL: 'Выбрать все',
  REPORT_RECIPIENTS_RESET: 'Сбросить',
  REPORT_RECIPIENTS_EMPTY: 'Участники не найдены',
  EXTERNAL_RECIPIENTS_LABEL: 'Введите Email внешних получателей',
  EXTERNAL_RECIPIENTS_PLACEHOLDER: 'Email получателя',
  EXTERNAL_RECIPIENTS_INVALID_ERROR: 'Проверьте email внешних получателей',
  EXTERNAL_RECIPIENTS_MAX_COUNT_ERROR: 'Можно добавить не более 10 внешних получателей',
  EXTERNAL_RECIPIENT_REMOVE_LABEL: (email: string) => `Удалить получателя ${email}`,
  REPORT_RECIPIENTS_EMPTY_ERROR: 'Выберите хотя бы одного получателя отчета',
  REPORT_ADDRESSES_EMPTY_ERROR: 'Выберите хотя бы один адрес',
  REPORT_ADDRESSES_MAX_COUNT_ERROR: 'Можно выбрать не более 2000 адресов',
  REPORT_ADDRESSES_BACKEND_INVALID_ERROR: 'Некоторые выбранные адреса недоступны для отчета',
  REPORT_RECIPIENTS_MAX_COUNT_ERROR: 'Можно выбрать не более 150 получателей отчета',
  REPORT_RECIPIENTS_BACKEND_INVALID_ERROR: 'Проверьте email получателей отчета',
  REQUEST_REPORT_SUCCESS_NOTIFICATION: (reportTitle: string) =>
    `${reportTitle} будет сформирован в течение нескольких минут и отправлен на электронную почту. ` +
    'Также отчет будет доступен в разделе «Отчеты»',
  REQUEST_REPORT_EXISTS_NOTIFICATION: (reportTitle: string) =>
    `${reportTitle} за указанный период был сформирован ранее и отправлен на электронную почту. ` +
    'Пожалуйста, проверьте свою электронную почту',
  REQUEST_REPORT_ERROR_NO_ADS_NOTIFICATION:
    'Для формирования отчёта недостаточно информации. Реклама или видео не найдены',
  WRONG_RANGE_START_MORE_END_ERROR: 'Дата начала не может быть позже даты окончания',
  WRONG_RANGE_MORE_MAX_ERROR: (maxDays: number) => `Максимальный период для выгрузки отчёта - ${maxDays} дней`,
  WRONG_RANGE_LESS_MIN_OR_MORE_MAX_ERROR: (maxDays: number) =>
    `Даты должны находиться в диапазоне последних ${maxDays} дней`,

  AUDIO_ADS_REPORT_MODAL_TITLE: 'Отчёт по аудиорекламе',
  VIDEO_ADS_REPORT_MODAL_TITLE: 'Отчёт по видеорекламе',
  VIDEO_WAVES_REPORT_MODAL_TITLE: 'Отчёт по видеоволнам',
  AUDIO_ADS_REPORT_NOTIFICATION_TITLE: 'Досрочный отчет по аудиорекламе',
  VIDEO_ADS_REPORT_NOTIFICATION_TITLE: 'Досрочный отчет по видеорекламе',
  VIDEO_WAVES_REPORT_NOTIFICATION_TITLE: 'Досрочный отчет по видеоволнам',
};
